

const strategy = () => {
  if ($(".strategy").length) {
    $(".strategy .section5 .hover-icon").on("click", function () {
      const $parent = $(this).parents(".item");
      const isActive = $parent.hasClass("active");
      if (isActive) {
        $parent.removeClass("active");
      }
      else {
        $(".strategy .section5 .item.active").removeClass("active");
        $parent.addClass("active");
      }
    })
  }
}

module.exports = strategy
